import { render, staticRenderFns } from "./cusAgree.vue?vue&type=template&id=ed2d9cba&scoped=true"
import script from "./cusAgree.vue?vue&type=script&lang=js"
export * from "./cusAgree.vue?vue&type=script&lang=js"
import style0 from "./cusAgree.vue?vue&type=style&index=0&id=ed2d9cba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2d9cba",
  null
  
)

export default component.exports